// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_EtD","cls2":"TranslationModal-cls2_Q-s TranslationModal-cls1_EtD"};